var app = angular.module('leonardo');

var FiltersBaseController = function (
  $scope,
  $q,
  $filter,
  $rootScope,
  $state,
  FilterService,
  AuthDataService
) {

  $scope.filterService = FilterService;
  $scope.authDataService = AuthDataService;

  $scope.only_account = $state.current.only_account;

  $scope.filters_options = [];

  $scope.no_reset_filters = false;

  $scope.initState = $state.current.url;

  $scope.filter = function () {
    $rootScope.$broadcast('filter-selection:updated');
  };

  $scope.clear = function () {
    var exceptions = [];
    angular.forEach($scope.filters_options, function (filter) {
      if (filter.group && filter.elements) {
        angular.forEach(filter.elements, function (groupFilter) {
          if (groupFilter.required) {
            exceptions.push(groupFilter.id);
          }
        });
      } else if (filter.required) {
        exceptions.push(filter.id);
      }
    });
    if (exceptions.length > 0) {
      FilterService.setFilter('filters', exceptions);
      exceptions.push('filters');
    }
    FilterService.clearFilters(false, exceptions, 'filters');
  };

  $scope.hideFilters = function () {
    var hide = true;
    angular.forEach($scope.filters_options, function (value) {
      if (value.elements) {
        angular.forEach(value.elements, function (element) {
          if (element.condition) {
            hide = false;
          }
        });
      } else {
        if (value.condition) {
          hide = false;
        }
      }
    });
    return hide;
  };

  $scope.$on('no_reset_filters:updated', function (event, value) {
    $scope.no_reset_filters = value;
  });

  $scope.$on('$destroy', function () {
    if (!$scope.no_reset_filters && $scope.initState !== $state.current.url) {
      FilterService.clearFilters(true, null, 'filters');
    }
  });
};

app.controller('FiltersBaseController', [
  '$scope',
  '$q',
  '$filter',
  '$rootScope',
  '$state',
  'FilterService',
  'AuthDataService',
  FiltersBaseController
]);
